import { Info } from 'lucide-react'
import { useCallback } from 'react'
import { Slide, toast, ToastOptions } from 'react-toastify'

type ToastType = 'info' | 'success' | 'danger' | 'warning' | ''

const useCustomToast = () => {
  const showToast = useCallback(
    (type: ToastType, title: string, className?: string) => {
      const toastOptions: ToastOptions = {
        className,
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        transition: Slide,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: 'light',
      }

      const handleGetColor = (type: string) => {
        switch (type) {
          case '':
            return 'var(--color-gray-700)'
          case 'danger':
            return 'var(--color-danger-500)'
          case 'success':
            return 'var(--color-success-500)'
          case 'warning':
            return 'var(--color-warning-500)'
          case 'info':
            return 'var(--color-info-500)'
        }
      }

      const toastContent = (type: string) => {
        return (
          <div className="flex items-center gap-4 rounded-lg p-4 mx-3">
            <Info
              size={20}
              style={{ color: handleGetColor(type) }}
              className="flex shrink-0"
            />
            <p className="text-label-lg text-gray-900 w-full">
              {title}
            </p>
          </div>
        )
      }

      switch (type) {
        case 'info':
          toast.info(toastContent(type), toastOptions)
          break
        case 'success':
          toast.success(toastContent(type), toastOptions)
          break
        case 'danger':
          toast.error(toastContent(type), toastOptions)
          break
        case 'warning':
          toast.warning(toastContent(type), toastOptions)
          break
        default:
          toast(toastContent(type), toastOptions)
          break
      }
    },
    []
  )

  return showToast
}

export default useCustomToast
